var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"switch-container",class:{ 'is-active': _vm.value },on:{"click":_vm.toggle}},[_c('span',{staticClass:"switch-core"})])}
var staticRenderFns = []

export { render, staticRenderFns }